module.exports = __webpack_public_path__ + "static/fonts/open-sans-bold.fc0dbb2.eot";